module.exports = __webpack_public_path__ + "static/media/1026294.1def9e27.jpg";